<template>
  <Transition name="muted-indicator">
    <button
      v-if="visible"
      class="muted-indicator"
      :aria-label="t('player.controls.clickToUnmute')"
      @click.stop="$emit('unmute')"
    >
      <svg class="muted-indicator__icon" viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
        <path :d="mdiVolumeOff" />
      </svg>
      <span class="muted-indicator__text">{{ t('player.controls.clickToUnmute') }}</span>
    </button>
  </Transition>
</template>

<script setup lang="ts">
import { mdiVolumeOff } from '@mdi/js'
import { useVideoI18n } from '../../i18n'

defineProps<{
  visible: boolean
}>()

defineEmits<{
  unmute: []
}>()

const { t } = useVideoI18n()
</script>

<style lang="scss" scoped>
.muted-indicator {
  position: absolute;
  top: 12px;
  left: 12px;
  z-index: 10;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  background: var(--vp-backdrop-medium);
  color: var(--vp-overlay-text-color, #ffffff);
  font-size: 13px;
  font-family: inherit;
  line-height: 1;
  cursor: pointer;
  backdrop-filter: blur(4px);
  transition: background 0.15s ease;

  &:hover {
    background: var(--vp-backdrop-heavy);
  }

  &:focus-visible {
    outline: 2px solid var(--vp-primary-color, #007bff);
    outline-offset: 2px;
  }

  &__icon {
    flex-shrink: 0;
  }

  &__text {
    white-space: nowrap;
  }
}

.muted-indicator-enter-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.muted-indicator-leave-active {
  transition: opacity 0.15s ease, transform 0.15s ease;
}

.muted-indicator-enter-from {
  opacity: 0;
  transform: translateY(-4px);
}

.muted-indicator-leave-to {
  opacity: 0;
}

@media (prefers-reduced-motion: reduce) {
  .muted-indicator-enter-active,
  .muted-indicator-leave-active {
    transition-duration: 1ms;
  }
}
</style>
